var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "light-folder",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_1778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 13.3726 5.37258 8 12 8H31.999C45.4727 8 47.1569 20 63.999 20H116C122.627 20 128 25.3726 128 32V104C128 110.627 122.627 116 116 116H12C5.37257 116 0 110.627 0 104V20Z",
    fill: "#52AFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 13.3726 5.37258 8 12 8H31.999C45.4727 8 47.1569 20 63.999 20H116C122.627 20 128 25.3726 128 32V104C128 110.627 122.627 116 116 116H12C5.37257 116 0 110.627 0 104V20Z",
    fill: "url(#paint0_linear_1302_1778)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1302_1778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 104V48C0 41.3726 5.37257 36 12 36L116 36C122.627 36 128 41.3726 128 48V104C128 110.627 122.627 116 116 116H12C5.37258 116 0 110.627 0 104Z",
    fill: "#73D0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 104V48C0 41.3726 5.37257 36 12 36L116 36C122.627 36 128 41.3726 128 48V104C128 110.627 122.627 116 116 116H12C5.37258 116 0 110.627 0 104Z",
    fill: "url(#paint1_radial_1302_1778)",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1302_1778",
    x: 0,
    y: 28,
    width: 128,
    height: 87.9998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.686275 0 0 0 0 0.878431 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1302_1778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1302_1778",
    x1: 63.999,
    y1: 28,
    x2: 63.999,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00529E",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1302_1778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64 52) rotate(90) scale(48 76.8001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_1778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1541944da4c6aea0e1c334571c663dac.svg";
export { ForwardRef as ReactComponent };